import { pubsub } from '@services';
import { getCurrentComparisonData, makeNewComparisonData, processNewComparisonData, fetchHTML } from '@utils';
import { n as nextTick, f as elementTransitionEnd, s as setInnerHTML, S as Swiper } from './swiper-core.js';
import { P as Pagination } from './swiper-pagination.js';
import { A as A11y } from './swiper-a11y.js';
import './swiper-classes-to-selector.js';
import './swiper-create-element.js';

/* eslint no-bitwise: ["error", { "allow": [">>"] }] */
function Controller({
  swiper,
  extendParams,
  on,
}) {
  extendParams({
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide', // or 'container'
    },
  });

  swiper.controller = {
    control: undefined,
  };
  function LinearSpline(x, y) {
    const binarySearch = function search() {
      let maxIndex;
      let minIndex;
      let guess;
      return (array, val) => {
        minIndex = -1;
        maxIndex = array.length;
        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;
          if (array[guess] <= val) {
            minIndex = guess;
          }
          else {
            maxIndex = guess;
          }
        }
        return maxIndex;
      };
    }();
    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1;
    // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.
    let i1;
    let i3;
    this.interpolate = function interpolate(x2) {
      if (!x2) return 0;

      // Get the indexes of x1 and x3 (the array indexes before and after given x2):
      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1;

      // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };
    return this;
  }
  function getInterpolateFunction(c) {
    swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
  }
  function setTranslate(_t, byController) {
    const controlled = swiper.controller.control;
    let multiplier;
    let controlledTranslate;
    const Swiper = swiper.constructor;
    function setControlledTranslate(c) {
      if (c.destroyed) return;

      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
      if (swiper.params.controller.by === 'slide') {
        getInterpolateFunction(c);
        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out
        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }
      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) {
          multiplier = 1;
        }
        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
      }
      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }
      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }
    if (Array.isArray(controlled)) {
      for (let i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTranslate(controlled[i]);
        }
      }
    }
    else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  }
  function setTransition(duration, byController) {
    const Swiper = swiper.constructor;
    const controlled = swiper.controller.control;
    let i;
    function setControlledTransition(c) {
      if (c.destroyed) return;
      c.setTransition(duration, swiper);
      if (duration !== 0) {
        c.transitionStart();
        if (c.params.autoHeight) {
          nextTick(() => {
            c.updateAutoHeight();
          });
        }
        elementTransitionEnd(c.wrapperEl, () => {
          if (!controlled) return;
          c.transitionEnd();
        });
      }
    }
    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTransition(controlled[i]);
        }
      }
    }
    else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }
  function removeSpline() {
    if (!swiper.controller.control) return;
    if (swiper.controller.spline) {
      swiper.controller.spline = undefined;
      delete swiper.controller.spline;
    }
  }
  on('beforeInit', () => {
    if (typeof window !== 'undefined' && (

      typeof swiper.params.controller.control === 'string' || swiper.params.controller.control instanceof HTMLElement)) {
      const controlElements = typeof swiper.params.controller.control === 'string' ? [...document.querySelectorAll(swiper.params.controller.control)] : [swiper.params.controller.control];
      controlElements.forEach((controlElement) => {
        if (!swiper.controller.control) swiper.controller.control = [];
        if (controlElement && controlElement.swiper) {
          swiper.controller.control.push(controlElement.swiper);
        }
        else if (controlElement) {
          const eventName = `${swiper.params.eventsPrefix}init`;
          const onControllerSwiper = (e) => {
            swiper.controller.control.push(e.detail[0]);
            swiper.update();
            controlElement.removeEventListener(eventName, onControllerSwiper);
          };
          controlElement.addEventListener(eventName, onControllerSwiper);
        }
      });
      return;
    }
    swiper.controller.control = swiper.params.controller.control;
  });
  on('update', () => {
    removeSpline();
  });
  on('resize', () => {
    removeSpline();
  });
  on('observerUpdate', () => {
    removeSpline();
  });
  on('setTranslate', (_s, translate, byController) => {
    if (!swiper.controller.control || swiper.controller.control.destroyed) return;
    swiper.controller.setTranslate(translate, byController);
  });
  on('setTransition', (_s, duration, byController) => {
    if (!swiper.controller.control || swiper.controller.control.destroyed) return;
    swiper.controller.setTransition(duration, byController);
  });
  Object.assign(swiper.controller, {
    setTranslate,
    setTransition,
  });
}

function appendSlide(slides) {
  const swiper = this;
  const {
    params,
    slidesEl,
  } = swiper;
  if (params.loop) {
    swiper.loopDestroy();
  }
  const appendElement = (slideEl) => {
    if (typeof slideEl === 'string') {
      const tempDOM = document.createElement('div');
      setInnerHTML(tempDOM, slideEl);
      slidesEl.append(tempDOM.children[0]);
      setInnerHTML(tempDOM, '');
    }
    else {
      slidesEl.append(slideEl);
    }
  };
  if (typeof slides === 'object' && 'length' in slides) {
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i]) appendElement(slides[i]);
    }
  }
  else {
    appendElement(slides);
  }
  swiper.recalcSlides();
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!params.observer || swiper.isElement) {
    swiper.update();
  }
}

function prependSlide(slides) {
  const swiper = this;
  const {
    params,
    activeIndex,
    slidesEl,
  } = swiper;
  if (params.loop) {
    swiper.loopDestroy();
  }
  let newActiveIndex = activeIndex + 1;
  const prependElement = (slideEl) => {
    if (typeof slideEl === 'string') {
      const tempDOM = document.createElement('div');
      setInnerHTML(tempDOM, slideEl);
      slidesEl.prepend(tempDOM.children[0]);
      setInnerHTML(tempDOM, '');
    }
    else {
      slidesEl.prepend(slideEl);
    }
  };
  if (typeof slides === 'object' && 'length' in slides) {
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i]) prependElement(slides[i]);
    }
    newActiveIndex = activeIndex + slides.length;
  }
  else {
    prependElement(slides);
  }
  swiper.recalcSlides();
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!params.observer || swiper.isElement) {
    swiper.update();
  }
  swiper.slideTo(newActiveIndex, 0, false);
}

function addSlide(index, slides) {
  const swiper = this;
  const {
    params,
    activeIndex,
    slidesEl,
  } = swiper;
  let activeIndexBuffer = activeIndex;
  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.recalcSlides();
  }
  const baseLength = swiper.slides.length;
  if (index <= 0) {
    swiper.prependSlide(slides);
    return;
  }
  if (index >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }
  let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
  const slidesBuffer = [];
  for (let i = baseLength - 1; i >= index; i -= 1) {
    const currentSlide = swiper.slides[i];
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }
  if (typeof slides === 'object' && 'length' in slides) {
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i]) slidesEl.append(slides[i]);
    }
    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  }
  else {
    slidesEl.append(slides);
  }
  for (let i = 0; i < slidesBuffer.length; i += 1) {
    slidesEl.append(slidesBuffer[i]);
  }
  swiper.recalcSlides();
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!params.observer || swiper.isElement) {
    swiper.update();
  }
  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  }
  else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeSlide(slidesIndexes) {
  const swiper = this;
  const {
    params,
    activeIndex,
  } = swiper;
  let activeIndexBuffer = activeIndex;
  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
  }
  let newActiveIndex = activeIndexBuffer;
  let indexToRemove;
  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
    for (let i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }
    newActiveIndex = Math.max(newActiveIndex, 0);
  }
  else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }
  swiper.recalcSlides();
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!params.observer || swiper.isElement) {
    swiper.update();
  }
  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  }
  else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeAllSlides() {
  const swiper = this;
  const slidesIndexes = [];
  for (let i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }
  swiper.removeSlide(slidesIndexes);
}

function Manipulation({
  swiper,
}) {
  Object.assign(swiper, {
    appendSlide: appendSlide.bind(swiper),
    prependSlide: prependSlide.bind(swiper),
    addSlide: addSlide.bind(swiper),
    removeSlide: removeSlide.bind(swiper),
    removeAllSlides: removeAllSlides.bind(swiper),
  });
}

class CompareStore {
  constructor() {
    this.items = [];
    this.specsData = new Map();
    this.specsConfig = null;
    this.subscribers = [];
    this.init();
  }

  init() {
    this.items = getCurrentComparisonData();
    this.unsubscribe = pubsub.subscribe('comparison:update', (payload) => {
      this.handleUpdate(payload);
    });
  }

  subscribe(callback) {
    this.subscribers.push(callback);
    return () => {
      this.subscribers = this.subscribers.filter(cb => cb !== callback);
    };
  }

  notify() {
    this.subscribers.forEach(callback => callback(this.items, this.specsData));
  }

  handleUpdate(payload) {
    if (payload.id === 'product-compare-section') return;
    this.items = payload.newComparisonItems;
    this.specsData.clear();
    this.notify();
  }

  getItems() {
    return this.items;
  }

  getSpecsData() {
    return this.specsData;
  }

  setSpecs(itemId, specs) {
    this.specsData.set(String(itemId), specs);
  }

  clearSpecs() {
    this.specsData.clear();
  }

  setSpecsConfig(config) {
    this.specsConfig = config;
  }

  getSpecsConfig() {
    return this.specsConfig;
  }

  removeItem(id) {
    const index = this.items.findIndex(item => Number(item.id) === Number(id));
    if (index === -1) return;

    const newData = makeNewComparisonData(this.items, false, index, this.items[index]);
    processNewComparisonData(newData, 'product-compare-section');
    this.items = newData;

    this.specsData.delete(String(id));

    this.notify();

    return index;
  }

  destroy() {
    if (this.unsubscribe) this.unsubscribe();
    this.subscribers = [];
  }
}

function formatKey(key) {
  // Match Liquid formatting: capitalize and replace underscores/hyphens with spaces
  return key
    .replace(/_/g, ' ')
    .replace(/-/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

/**
 * Parses the "namespace.key | Label | Value" lines of a specifications group block.
 * Row order is the configured order. Label falls back to the formatted key.
 */
function parseMetafieldRows(metafieldsText) {
  if (!metafieldsText) return [];

  return metafieldsText
    .split('\n')
    .map((line) => {
      const [reference = '', label = '', fixedValue = ''] = line.split('|').map(part => part.trim());
      const [namespace, key] = reference.split('.');
      if (!namespace || !key) return null;

      return {
        namespace,
        key,
        label: label || formatKey(key),
        fixedValue,
      };
    })
    .filter(Boolean);
}

function clonePrototype(template, selector, errorContext) {
  if (!template || !template.content) {
    if (errorContext) {
      console.error(`Missing ${errorContext}`);
    }
    return null;
  }

  const prototype = template.content.querySelector(selector);
  if (!prototype) {
    if (errorContext) {
      console.error(`Prototype not found for ${errorContext}`);
    }
    return null;
  }

  return prototype.cloneNode(true);
}

function createSlideWithContent(content, slideTemplate) {
  if (!content) {
    return null;
  }

  let slide = null;
  if (slideTemplate) {
    slide = clonePrototype(slideTemplate, '[data-compare-slide]', 'compare slide template');
  }

  if (slide) {
    slide.appendChild(content);
    return slide;
  }

  const fallback = document.createElement('div');
  fallback.appendChild(content);
  return fallback;
}

class CardRenderer {
  constructor(store, elements) {
    this.store = store;
    this.grid = elements.grid;
    this.gridDesktop = elements.gridDesktop;
    this.prototypeTemplate = elements.prototypeTemplate;
    this.skeletonTemplate = elements.skeletonTemplate;

    // Read specs configuration from section
    const configScript = document.querySelector('script[data-specs-config]');
    if (configScript) {
      try {
        this.specsConfig = JSON.parse(configScript.textContent);
        this.store.setSpecsConfig(this.specsConfig);
      }
      catch (e) {
        console.error('Failed to parse specs config', e);
        this.specsConfig = { groups: []};
      }
    }
    else {
      this.specsConfig = { groups: []};
    }
  }

  async render(items) {
    this.showSkeletons(items);

    let wrappers = [];
    try {
      wrappers = await Promise.all(items.map(item => this.createProductCardWrapper(item)));
    }
    catch (error) {
      console.error('Failed to build comparison cards', error);
    }

    this.replaceSkeletons(wrappers);
  }

  async createProductCardWrapper(item) {
    const wrapper =
      clonePrototype(this.prototypeTemplate, '[data-product-card-wrapper]', 'card wrapper template') ||
      document.createElement('div');
    wrapper.dataset.productId = item.id;

    try {
      const url = `${item.productUrl}?section_id=product-compare-card-renderer`;
      const doc = await fetchHTML(url);
      const content = doc.querySelector('#shopify-section-product-compare-card-renderer');

      if (content) {
        wrapper.innerHTML = content.innerHTML;
        this.extractProductSpecs(wrapper, item.id);
      }
      else {
        console.error('No content found for', item.title);
      }
    }
    catch (e) {
      console.error('Failed to fetch product card', e);
    }

    return wrapper;
  }

  extractProductSpecs(wrapper, itemId) {
    const script = wrapper.querySelector('script[data-product-specs]');
    if (!script) {
      return;
    }

    try {
      const allMetafields = JSON.parse(script.textContent);
      const specsConfig = this.store.getSpecsConfig();

      if (!specsConfig || !specsConfig.groups || specsConfig.groups.length === 0) {
        this.store.setSpecs(String(itemId), []);
        return;
      }

      // Pick the configured metafields for this product, in configured order.
      // Metafields that are blank for this product are absent from the renderer output and skipped.
      const transformedSpecs = [];

      specsConfig.groups.forEach((groupConfig) => {
        parseMetafieldRows(groupConfig.metafields).forEach((row) => {
          const spec = allMetafields[row.namespace]?.[row.key];
          if (!spec) return;

          transformedSpecs.push({
            group: groupConfig.heading,
            key: row.label,
            value: row.fixedValue || spec.value,
          });
        });
      });

      this.store.setSpecs(String(itemId), transformedSpecs);
    }
    catch (e) {
      console.error('Failed to parse specs', e);
    }
  }

  showSkeletons(items) {
    if (!this.grid || !this.skeletonTemplate) return;

    const fragment = document.createDocumentFragment();
    items.forEach(() => {
      const skeleton = this.createSkeletonCard();
      const slide = createSlideWithContent(skeleton, this.prototypeTemplate);
      if (slide) {
        fragment.appendChild(slide);
      }
    });

    this.grid.appendChild(fragment);

    if (this.gridDesktop) {
      const desktopFragment = document.createDocumentFragment();
      items.forEach(() => {
        const skeleton = this.createSkeletonCard();
        if (skeleton) desktopFragment.appendChild(skeleton);
      });
      this.gridDesktop.appendChild(desktopFragment);
    }
  }

  createSkeletonCard() {
    return clonePrototype(this.skeletonTemplate, '[data-compare-skeleton]');
  }

  replaceSkeletons(wrappers = []) {
    // Simply clear and rebuild everything
    if (this.grid) {
      this.grid.innerHTML = '';
    }
    if (this.gridDesktop) {
      this.gridDesktop.innerHTML = '';
    }

    if (!wrappers.length) return;

    const fragment = document.createDocumentFragment();
    wrappers.forEach((wrapper) => {
      if (!wrapper) return;
      const slide = createSlideWithContent(wrapper.cloneNode(true), this.prototypeTemplate);
      if (slide) {
        fragment.appendChild(slide);
      }
    });

    this.grid.appendChild(fragment);

    if (this.gridDesktop) {
      const desktopFragment = document.createDocumentFragment();
      wrappers.forEach((wrapper) => {
        if (wrapper) desktopFragment.appendChild(wrapper.cloneNode(true));
      });
      this.gridDesktop.appendChild(desktopFragment);
    }
  }

  clear() {
    if (this.grid) this.grid.innerHTML = '';
    if (this.gridDesktop) this.gridDesktop.innerHTML = '';
  }
}

class SpecsRenderer {
  constructor(store, elements) {
    this.store = store;
    this.container = elements.specsContainer;
    this.prototypeTemplate = elements.prototypeTemplate;
    this.skeletonTemplate = elements.specsSkeletonTemplate;
    this.specsGroupTemplate = elements.specsGroupTemplate;
    this.mobileMediaQuery = window.matchMedia('(max-width: 1023px)');
  }

  render() {
    const specsData = this.store.getSpecsData();
    if (!this.container || specsData.size === 0) {
      this.removeSkeletonSpecs();
      return;
    }

    // Save current state of collapsibles
    const savedState = this.saveState();

    this.removeSkeletonSpecs();
    this.container.innerHTML = '';

    if (!this.specsGroupTemplate) {
      console.error('Comparison specs template not found');
      return;
    }

    const groups = this.collectSpecsGroups(specsData);
    this.renderSpecsGroups(groups, savedState);

    // Restore state of collapsibles
    if (savedState && savedState.size > 0) {
      this.restoreState(savedState);
    }
  }

  saveState() {
    const openGroups = new Set();
    if (!this.container) return null;

    const collapsibles = this.container.querySelectorAll('collapsible-element[data-specs-group]');
    if (collapsibles.length === 0) return null;

    collapsibles.forEach((collapsible) => {
      const button = collapsible.querySelector('button[aria-expanded="true"]');
      if (button) {
        const groupName = button.querySelector('span:first-child')?.textContent;
        if (groupName) {
          openGroups.add(groupName);
        }
      }
    });

    return openGroups;
  }

  restoreState(savedState) {
    if (!this.container) return;

    const collapsibles = this.container.querySelectorAll('collapsible-element[data-specs-group]');
    collapsibles.forEach((collapsible) => {
      const button = collapsible.querySelector('button');
      const content = collapsible.querySelector('.collapsible__content');
      const groupName = button?.querySelector('span:first-child')?.textContent;
      const shouldOpen = groupName && savedState.has(groupName);

      button?.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      content?.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
    });
  }

  collectSpecsGroups(specsData) {
    // Groups and rows follow the block configuration order; rows no compared product has a value for are hidden.
    const groups = new Map();
    const specsConfig = this.store.getSpecsConfig();
    const allSpecs = Array.from(specsData.values()).flat();

    (specsConfig?.groups || []).forEach((groupConfig) => {
      parseMetafieldRows(groupConfig.metafields).forEach((row) => {
        const hasValue = allSpecs.some(spec => spec.group === groupConfig.heading && spec.key === row.label);
        if (!hasValue) return;

        if (!groups.has(groupConfig.heading)) {
          groups.set(groupConfig.heading, new Set());
        }
        groups.get(groupConfig.heading).add(row.label);
      });
    });

    return groups;
  }

  renderSpecsGroups(groups, savedState) {
    let groupIndex = 0;

    for (const [groupName, keys] of groups) {
      groupIndex++;
      const contentWrapper = this.buildGroupContent(groupName, keys);
      const groupId = `compare-specs-${groupIndex}-${groupName.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
      const isFirstGroup = savedState === null && groupIndex === 1;
      this.appendGroupToContainer(groupName, groupId, contentWrapper, isFirstGroup);
    }
  }

  buildGroupContent(groupName, keys) {
    const contentWrapper =
      clonePrototype(this.prototypeTemplate, '[data-specs-content]', 'specs content template') ||
      document.createElement('div');

    keys.forEach((key) => {
      const keyWrapper = this.buildKeySection(groupName, key);
      if (keyWrapper) {
        contentWrapper.appendChild(keyWrapper);
      }
    });

    return contentWrapper;
  }

  buildKeySection(groupName, key) {
    const keyWrapper =
      clonePrototype(this.prototypeTemplate, '[data-specs-key]', 'specs key template') ||
      document.createElement('div');

    const title = keyWrapper.querySelector('[data-specs-key-title]');
    if (title) {
      title.textContent = key;
    }

    const valuesContainer = keyWrapper.querySelector('[data-specs-values]') || keyWrapper;
    const valuesGrid = this.buildValuesGrid(groupName, key);
    if (valuesGrid) {
      valuesContainer.appendChild(valuesGrid);
    }

    return keyWrapper;
  }

  buildValuesGrid(groupName, key) {
    if (this.mobileMediaQuery.matches) {
      const mobileGrid = this.buildMobileValuesSwiper(groupName, key);
      if (mobileGrid) {
        return mobileGrid;
      }
    }

    return this.buildDesktopValuesGrid(groupName, key);
  }

  buildDesktopValuesGrid(groupName, key) {
    const valuesGrid =
      clonePrototype(this.prototypeTemplate, '[data-specs-grid]', 'specs grid template') ||
      document.createElement('div');

    this.store.getItems().forEach((item) => {
      const valueNode = this.buildSpecValueNode(groupName, key, item);
      if (valueNode) {
        valuesGrid.appendChild(valueNode);
      }
    });

    return valuesGrid;
  }

  buildMobileValuesSwiper(groupName, key) {
    const swiper =
      clonePrototype(
        this.prototypeTemplate,
        '[data-compare-specs-swiper]',
        'specs swiper template',
      ) || null;
    const wrapper = swiper?.querySelector('[data-specs-swiper-wrapper]');

    if (!swiper || !wrapper) {
      return null;
    }

    this.store.getItems().forEach((item) => {
      const slide = clonePrototype(
        this.prototypeTemplate,
        '[data-specs-swiper-slide]',
        'specs swiper slide template',
      );
      if (!slide) {
        return;
      }
      const valueNode = this.buildSpecValueNode(groupName, key, item);
      if (valueNode) {
        slide.appendChild(valueNode);
      }
      wrapper.appendChild(slide);
    });

    return swiper;
  }

  buildSpecValueNode(groupName, key, item) {
    const valueNode =
      clonePrototype(this.prototypeTemplate, '[data-specs-value]', 'specs value template') ||
      document.createElement('div');
    valueNode.textContent = this.getItemSpecValue(groupName, key, item);
    return valueNode;
  }

  getItemSpecValue(groupName, key, item) {
    const itemSpecs = this.store.getSpecsData().get(String(item.id)) || [];
    const spec = itemSpecs.find(s => s.key === key && s.group === groupName);
    return spec ? spec.value : '-';
  }

  appendGroupToContainer(groupName, groupId, contentWrapper, isFirstGroup = false) {
    const clone = this.specsGroupTemplate.content.cloneNode(true);
    const collapsibleElement = clone.querySelector('collapsible-element[data-specs-group]');

    if (!collapsibleElement) {
      console.error('Collapsible element not found in template');
      return;
    }

    const button = collapsibleElement.querySelector('button');
    const contentDiv = collapsibleElement.querySelector('.collapsible__content');
    const wrapperDiv = collapsibleElement.querySelector('[data-content-wrapper]');

    if (button && contentDiv && wrapperDiv) {
      button.setAttribute('aria-controls', groupId);
      button.querySelector('span:first-child').textContent = groupName;
      contentDiv.id = groupId;
      wrapperDiv.appendChild(contentWrapper);

      if (isFirstGroup) {
        button.setAttribute('aria-expanded', 'true');
        contentDiv.setAttribute('aria-hidden', 'false');
      }

      this.container.appendChild(clone);
    }
    else {
      console.error('Template structure mismatch', {
        button,
        contentDiv,
        wrapperDiv,
      });
    }
  }

  showSkeletonSpecs() {
    if (!this.container || !this.skeletonTemplate) return;

    const skeletons = Array.from({ length: 2 }, () => this.createSkeletonSpec()).filter(Boolean);
    if (!skeletons.length) return;

    const fragment = document.createDocumentFragment();
    skeletons.forEach(skeleton => fragment.appendChild(skeleton));
    this.container.appendChild(fragment);
  }

  createSkeletonSpec() {
    return clonePrototype(this.skeletonTemplate, '[data-specs-skeleton]');
  }

  removeSkeletonSpecs() {
    if (!this.container) return;
    this.container.querySelectorAll('[data-specs-skeleton]').forEach(node => node.remove());
  }

  clear() {
    if (this.container) this.container.innerHTML = '';
  }
}

class SwiperManager {
  constructor(elements) {
    this.cardsSwiperContainer = elements.cardsSwiperContainer;
    this.specsContainer = elements.specsContainer;
    this.swiperInstances = [];
    this.mainSwiper = null;
    this.mobileMediaQuery = window.matchMedia('(max-width: 1023px)');
  }

  init(itemsLength) {
    if (!this.mobileMediaQuery.matches || itemsLength <= 1) {
      return;
    }

    if (!this.cardsSwiperContainer) {
      return;
    }

    const swiperOptions = {
      modules: [Controller, Pagination, Manipulation, A11y],
      slidesPerView: 1.2,
      spaceBetween: 16,
      watchOverflow: true,
      autoHeight: true,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        bulletElement: 'button',
      },
    };

    const specsSwiperElements = this.specsContainer
      ? Array.from(this.specsContainer.querySelectorAll('[data-compare-specs-swiper]'))
      : [];

    const specsSwipers = [];

    this.mainSwiper = new Swiper(this.cardsSwiperContainer, {
      ...swiperOptions,
      controller: {
        control: specsSwipers,
      },
    });

    specsSwiperElements.forEach((element) => {
      const swiper = new Swiper(element, {
        ...swiperOptions,
        controller: {
          control: this.mainSwiper,
        },
      });
      specsSwipers.push(swiper);
    });

    if (specsSwipers.length > 0 && this.mainSwiper.controller) {
      this.mainSwiper.controller.control = specsSwipers;
    }

    this.swiperInstances = [this.mainSwiper, ...specsSwipers];
  }

  destroy() {
    this.swiperInstances.forEach((swiper) => {
      if (swiper && typeof swiper.destroy === 'function') {
        swiper.destroy(true, true);
      }
    });
    this.swiperInstances = [];
    this.mainSwiper = null;
  }

  removeSlide(index) {
    if (this.mainSwiper && typeof this.mainSwiper.removeSlide === 'function') {
      this.mainSwiper.removeSlide(index);
    }

    this.swiperInstances.forEach((swiper) => {
      if (swiper && swiper !== this.mainSwiper && typeof swiper.removeSlide === 'function') {
        swiper.removeSlide(index);
      }
    });
  }
}

class ProductCompareSection extends HTMLElement {
  connectedCallback() {
    this.initElements();

    if (!this.elements.grid || !this.elements.emptyMessage || !this.elements.mainContent) {
      console.error('Missing required elements', this.elements);
      return;
    }

    this.store = new CompareStore();
    this.cardRenderer = new CardRenderer(this.store, this.elements);
    this.specsRenderer = new SpecsRenderer(this.store, this.elements);
    this.swiperManager = new SwiperManager(this.elements);

    this.mobileMediaQuery = window.matchMedia('(max-width: 1023px)');

    this.render();

    this.unsubscribe = this.store.subscribe((items, specsData) => {
      this.handleStoreUpdate(items, specsData);
    });

    this.bindEvents();
  }

  initElements() {
    this.elements = {
      grid: this.querySelector('[data-compare-grid]'),
      gridDesktop: this.querySelector('[data-compare-grid-desktop]'),
      cardsSwiperContainer: this.querySelector('[data-compare-cards-swiper]'),
      emptyMessage: this.querySelector('[data-empty-message]'),
      mainContent: this.querySelector('[data-main-content]'),
      specsContainer: this.querySelector('[data-compare-specs]'),
      skeletonTemplate: this.querySelector('[data-compare-skeleton-template]'),
      specsSkeletonTemplate: this.querySelector('[data-specs-skeleton-template]'),
      prototypeTemplate: this.querySelector('[data-compare-prototypes]'),
      specsGroupTemplate: this.querySelector('[data-specs-group-template]'),
    };
  }

  disconnectedCallback() {
    if (this.store) this.store.destroy();
    if (this.swiperManager) this.swiperManager.destroy();
    if (this.mobileMediaQuery && this.handleBreakpointChange) {
      this.mobileMediaQuery.removeEventListener('change', this.handleBreakpointChange);
    }
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize);
    }
  }

  bindEvents() {
    this.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-remove-compare]');
      if (removeButton) {
        this.handleRemoveItem(removeButton);
      }
    });

    let resizeTimeout;
    this.handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const items = this.store.getItems();
        if (items.length > 0) {
          this.swiperManager.destroy();
          this.specsRenderer.render();
          this.swiperManager.init(items.length);
        }
      }, 250);
    };

    this.handleBreakpointChange = () => {
      const items = this.store.getItems();
      if (items.length > 0) {
        this.swiperManager.destroy();
        this.specsRenderer.render();
        this.swiperManager.init(items.length);
      }
    };

    this.mobileMediaQuery.addEventListener('change', this.handleBreakpointChange);
    window.addEventListener('resize', this.handleResize);
  }

  handleStoreUpdate() {
    this.render();
  }

  async render() {
    const items = this.store.getItems();
    this.swiperManager.destroy();

    if (items.length === 0) {
      this.showEmptyState();
      return;
    }

    this.showMainContent();

    await this.cardRenderer.render(items);

    this.specsRenderer.render();

    this.swiperManager.init(items.length);
  }

  showEmptyState() {
    this.elements.mainContent.classList.add('hidden');
    this.elements.emptyMessage.classList.remove('hidden');
    this.cardRenderer.clear();
    this.specsRenderer.clear();
  }

  showMainContent() {
    this.elements.mainContent.classList.remove('hidden');
    this.elements.emptyMessage.classList.add('hidden');
    this.cardRenderer.clear();
  }

  handleRemoveItem(button) {
    const wrapper = button.closest('[data-product-id]');
    if (!wrapper) return;

    const id = wrapper.dataset.productId;
    this.store.removeItem(id);
  }
}

customElements.define('product-compare-section', ProductCompareSection);
